import { html } from 'lit';
import { t } from 'i18next';
export const Header = ({ isSeller, itemTitle, }) => {
    return html `
    <header class="flex flex-col mb-4">
      <p class="m-0">
        ${isSeller ? t('You sold') : t('You bought')}
      </p>
      <p class="m-0 mb-8 strong">${itemTitle}</p>
    </header>
  `;
};
//# sourceMappingURL=Header.js.map